/* eslint-disable */
// from https://github.com/ungap/global-this/blob/3353061d0c6a214108aab9b497162b2f2ca78223/index.js
export const ensureGlobalThis = () =>
  (function (Object) {
    typeof globalThis !== 'object' &&
      // @ts-ignore
      (this
        ? get()
        : (Object.defineProperty(Object.prototype, '_T_', {
            configurable: true,
            get: get,
          }),
          // @ts-ignore
          _T_));
    function get() {
      // @ts-ignore
      var global = this || self;
      global.globalThis = global;
      // @ts-ignore
      delete Object.prototype._T_;
    }
  })(Object);
